import React from 'react';
import { EditableField } from '../ui/EditableField';
import { TagInput } from '../ui/TagInput';
import type { SupportProgramDetails } from './supportProgramProfile';

interface SupportProgramSectionProps {
  values: SupportProgramDetails;
  isEditing: boolean;
  onChange: (next: SupportProgramDetails) => void;
}

/** Champs propres au programme d'appui (cahier des charges 4.4). */
export const SupportProgramSection: React.FC<SupportProgramSectionProps> = ({
  values,
  isEditing,
  onChange,
}) => {
  const set = <K extends keyof SupportProgramDetails>(field: K, value: SupportProgramDetails[K]) => {
    onChange({ ...values, [field]: value });
    return Promise.resolve();
  };

  return (
    <section className="bg-white rounded-lg border border-gray-200 p-6">
      <h2 className="text-lg font-medium text-gray-900 mb-2">Programme d'appui</h2>
      <p className="text-sm text-gray-500 mb-6">
        Le programme qui accompagne des AVEC : qui le porte, qui le finance, où et quand.
      </p>
      <div className="space-y-6">
        <EditableField
          label="Organisation porteuse"
          value={values.organisationPorteuse}
          onSave={(v) => set('organisationPorteuse', String(v))}
          placeholder="ONG ou projet qui met en oeuvre le programme"
          disabled={!isEditing}
        />
        <TagInput
          label="Bailleurs"
          value={values.bailleurs}
          onSave={(tags) => set('bailleurs', tags)}
          disabled={!isEditing}
          placeholder="Ajoutez chaque bailleur"
        />
        <TagInput
          label="Zones d'intervention"
          value={values.zonesIntervention}
          onSave={(tags) => set('zonesIntervention', tags)}
          disabled={!isEditing}
          placeholder="Province, territoire ou chefferie"
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <EditableField
            label="Début du programme"
            value={values.dateDebut}
            onSave={(v) => set('dateDebut', String(v))}
            type="date"
            disabled={!isEditing}
          />
          <EditableField
            label="Fin du programme"
            value={values.dateFin}
            onSave={(v) => set('dateFin', String(v))}
            type="date"
            disabled={!isEditing}
          />
        </div>
      </div>
    </section>
  );
};

export default SupportProgramSection;
